import { Button, ButtonA, ButtonSpan } from './Button';

export const ButtonLink = ButtonA;
export const ButtonS = ButtonSpan;

export default Button;
